module.exports = __webpack_public_path__ + "assets/img/B1.42e122e3.png";